module.exports = __webpack_public_path__ + "img/map.c2b1a9c5.svg";